<template>
  <i-select :filterable="true" :clearable="true" :value="value" @input="input">
    <i-option v-for="(item, key) in list" :key="key" :label="get_label(item)" :value="item.id" />
  </i-select>
</template>

<script>
  import { CampaignsService } from '@autoinformer/services/CampaignsService';

  export default {
    props: {
      value: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      list: []
    }),
    created() {
      CampaignsService.getSelect().then((data) => {
        this.list = data || [];
      });
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      },
      get_label(item) {   
        return `${item.name} ${
          item.completed ? `(${this.$t('autoinformer.campaign.deleted')})` : ''
        }`;
      }
    }
  };
</script>
